import { ExtractedUserMetaType } from '@/modules/ai/constants/ExtractedUserMetaType';
import { ExtractedUserResidualBeneficiaryMeta } from '@/modules/ai/models/meta/ExtractedUserResidualBeneficiaryMeta';
import { ExtractedUserSpecificBeneficiaryMeta } from '@/modules/ai/models/meta/ExtractedUserSpecificBeneficiaryMeta';
import { ExtractionType } from '@/modules/ai/constants/ExtractionType';

export class ExtractedUserMetaFactory {
  static build(
    metaType: ExtractedUserMetaType | undefined,
    model = {}
  ): ExtractedUserResidualBeneficiaryMeta | ExtractedUserSpecificBeneficiaryMeta | undefined {
    switch (metaType) {
      case ExtractedUserMetaType.EXTRACTED_USER_RESIDUAL_BENEFICIARY_META:
        return new ExtractedUserResidualBeneficiaryMeta(model);
      case ExtractedUserMetaType.EXTRACTED_USER_SPECIFIC_BENEFICIARY_META:
        return new ExtractedUserSpecificBeneficiaryMeta(model);
      default:
        return undefined;
    }
  }

  static getMetaTypeByExtractionType(
    extractionType: ExtractionType | undefined
  ): ExtractedUserMetaType | undefined {
    switch (extractionType) {
      case ExtractionType.WILL_RESIDUAL_BENEFICIARIES:
        return ExtractedUserMetaType.EXTRACTED_USER_RESIDUAL_BENEFICIARY_META;
      case ExtractionType.WILL_SPECIFIC_BENEFICIARIES:
        return ExtractedUserMetaType.EXTRACTED_USER_SPECIFIC_BENEFICIARY_META;
      default:
        return undefined;
    }
  }
}
